import React, { useEffect, useRef } from 'react';
import './MessageSnackBar.css';
import IconCheckCircleFill from 'assets/SVGs/IconCheckCircleFill';
import IconXCircle from 'assets/SVGs/IconXCircle';

const MessageSnackBar = ({
  message,
  isVisible = false,
  onDismiss,
  style = {},
  textStyle = {},
  containerStyle = {},
  type = "error", // 'error' or 'success'
  autoHideDuration = 1700,
  constrainWidth = true,
}) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (isVisible && message) {
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Auto hide after specified duration (only if duration > 0)
      if (autoHideDuration > 0) {
        timeoutRef.current = setTimeout(() => {
          if (onDismiss) {
            onDismiss();
          }
        }, autoHideDuration);
      }
    }

    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [isVisible, message, autoHideDuration, onDismiss]);

  if (!isVisible || !message) return null;

  // Determine background color based on type
  const backgroundColor = type === "success" ? "#B8CD82" : "#DB4E3B"; // Light green for success, primary for error

  // Determine icon based on type
  const getIcon = () => {
    if (type === "success") {
      return (
        <div className="message-snackbar-icon">
          <IconCheckCircleFill size={20} color="#FFFFFF" />
        </div>
      );
    } else {
      return (
        <div className="message-snackbar-icon message-snackbar-close-icon" onClick={onDismiss}>
          <IconXCircle size={20} color="#FFFFFF" />
        </div>
      );
    }
  };

  return (
    <div className={constrainWidth ? 'message-snackbar-constrained' : ''} style={{ width: constrainWidth ? undefined : '100%' }}>
      <div
        className={`message-snackbar ${isVisible ? 'message-snackbar-visible' : ''}`}
        style={{
          backgroundColor: backgroundColor,
          width: '100%',
          maxWidth: '100%',
          ...style,
          ...containerStyle,
        }}
      >
        <div className="message-snackbar-content">
          {getIcon()}
          <div className="message-snackbar-message">
            <span
              className={`message-snackbar-text ${type === "success" ? "message-snackbar-success-text" : "message-snackbar-error-text"}`}
              style={textStyle}
            >
              {message}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageSnackBar;
